export default {"src":"/_next/static/media/edit_gray_v2.a6d6cbcc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};